import { POST } from "../../../APiHelper/API"


export const removeTeamFromCupAPI = (
    team_id,
    cup_id,
    onSuccess,
    onError
) => {
    const data = {
        team_id: team_id,
        cup_id: cup_id
    }
    POST("/api/v1/cups/remove_team", data, onSuccess, onError)
}